module.exports = __webpack_public_path__ + "img/1.4e80ab6d.jpg";